<template>
  <v-card
    class="fill-height text-left d-flex flex-column dsfr"
    outlined
    @click="handleCardClick"
    style="cursor: pointer;"
  >
    <v-card-title class="font-weight-bold">
      {{ study.title }}
    </v-card-title>
    <v-card-subtitle class="text-muted">
      {{ study.canteenName }}
    </v-card-subtitle>

    <v-card-text class="py-2">
      <p class="mb-1">
        <strong>Début :</strong>
        {{ study.start }}
      </p>
      <p class="mb-1">
        <strong>Fin :</strong>
        {{ study.end }}
      </p>
    </v-card-text>

    <v-spacer></v-spacer>

    <v-card-actions class="px-4 py-4">
      <v-spacer></v-spacer>
      <v-icon color="primary">$arrow-right-line</v-icon>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    study: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      surveyLink: null,
    }
  },
  methods: {
    async fetchCanteen() {
      try {
        const id = this.study.id // Récupère l'ID de la cantine depuis l'étude
        const survey = await this.$store.dispatch("fetchSurveyDetails", { id }) // Appelle l'action Vuex
        this.surveyLink = survey
      } catch (error) {
        console.error("Erreur lors de la récupération du surveyLink :", error)
      }
    },
    async handleCardClick() {
      await this.fetchCanteen()
      if (this.surveyLink && this.surveyLink[0].slug) {
        const targetUrl = `/surveys/dashboard/summary/survey/${this.surveyLink[0].slug}/`
        window.location.href = targetUrl // Redirige vers l'URL cible
        // this.$router.push(targetUrl)
      } else {
        console.error("surveyLink ou surveyLink.slug est manquant")
      }
    },
  },
}
</script>

<style scoped>
.study-card {
  max-width: 400px;
  border-radius: 8px;
}

.v-card-title {
  font-size: 1.25rem;
  color: #1e88e5; /* Couleur principale */
}

.v-card-subtitle {
  font-size: 0.9rem;
  color: #757575; /* Couleur secondaire (gris) */
}

.v-card-text p {
  margin: 0;
  color: #424242; /* Texte principal */
}

.v-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-btn {
  background-color: #e3f2fd; /* Fond bleu clair */
}
.v-btn:hover {
  background-color: #bbdefb; /* Fond bleu plus sombre au hover */
}
</style>
